import React, { useRef, useEffect, useState } from 'react';

window.stopVideo = function () {
  player.stopVideo();
}

const Video = (config) => {
  const videoEl = useRef(); 

  const [video, setVideo] = useState({ id: config.id, rateo: config.rateo || (480 / 640), player: null, played: false });

  // questa tecnica utilizza il useRef per wrappare lo stato e farlo accedere anche agli eventi esterni

  const extVideo = React.useRef(video);
  const extSetVideo = data => {
    extVideo.current = data;

    setVideo(data);
  };

  // console.log("!!Video!!", video)

  var onPlayerReady = (event) => {
    // console.log("!!onPlayerReady!!");

    if (video.played) {

    }
    else {
      event.target.playVideo();
    }
  }

  var onPlayerStateChange = (event) => {
    // console.log("!!onPlayerStateChange!!", extVideo.current.played);

    if (event.data == YT.PlayerState.PLAYING) {
      // console.log("!!onPlayerStateChange set!!");

      extSetVideo({
        ...extVideo.current,
        played: true
      });
    }
  }

  useEffect(() => {
    const script = document.createElement('script');

    script.src = "https://www.youtube.com/iframe_api";
    script.async = true;

    document.body.appendChild(script);

    window.onYouTubeIframeAPIReady = () => {
      // console.log("!!onYouTubeIframeAPIReady!!");

      var w = videoEl.current.clientWidth;
      var h = w * extVideo.current.rateo;

      extSetVideo({ ...extVideo.current, 
        player: new YT.Player(videoEl.current.childNodes[0],
          {
            height: h,
            width: w,
            videoId: extVideo.current.id,
            events: {
              'onReady': onPlayerReady,
              'onStateChange': onPlayerStateChange
            }
          })
        }
      );
    }

    window.onresize = function () {
      var w = videoEl.current.clientWidth;
      var h = w * extVideo.current.rateo;

      // modifichiamo le dimensioni dell'iframe di YouTube

      videoEl.current.childNodes[0].width = w;
      videoEl.current.childNodes[0].height = h;
    };

    return () => {
      document.body.removeChild(script);
    }
  }, []);

  // creiamo un sotto div che verrà sostituito dal iframe di YouTube

  return (
    <div ref={videoEl} style={{width: "100%"}}><div></div></div>
  );
}

export { Video };
